<template>
  <v-dialog
    v-model="show"
    width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loadingData ? true : false"
  >
    <v-card>
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-row no-gutters class="px-2">
        <v-col cols="11">
          <v-card-title
            class="no-break text-h5 text-center justify-center font-weight-bold"
          >
            {{ cdTitle }}
          </v-card-title>
        </v-col>
        <v-col cols="1" class="justify-end" v-if="Object.keys(item).length == 0">
          <v-icon
            ref="cancel"
            data-testid="cancel-button"
            min-width="100"
            class="rounded-xxl text-none my-6"
            @click="show = false"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="Object.keys(item).length == 0 ? addLink() : editLink()"
          @submit.prevent
        >
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelTitle") }}
          </p>
          <v-text-field
            v-model="title"
            data-testid="title-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2"
            :placeholder="cdInputPlaceholder"
            :rules="titleRules"
          />
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelURL") }}
          </p>
          <v-text-field
            v-model="url"
            data-testid="url-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2"
            :placeholder="$t('confirmationDialogInputPlaceholderEmbedLink')"
            :rules="urlRules"
            :error-messages="errors"
            :hint="$t('confirmationDialogInputHintEmbedLink')"
            type="url"
          />         
          <v-card-actions class="px-0 pt-0">
            <v-spacer />
            <v-btn
              v-if="Object.keys(item).length > 0"
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4 mb-2 mb-md-0"
              :class="{'disable-events': loadingData}"
              @click="show=false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="add-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none"
              :loading="loadingData"
              @click="Object.keys(item).length == 0 ? addLink() : editLink()"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from "../rules/formRules.js";
import  { addHubLink, updateHubLink } from "../api/hubApi";

import i18n from "../plugins/i18n";
import { } from "../api/hubApi";
import AlertMessages  from './AlertMessages'
      
const isUrl = require("is-valid-http-url");

export default {
  components: {
    AlertMessages
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdText: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: "",
    },
    cdInputPlaceholder: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      valid: true,
      titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
      title: "",
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false,
      buttonDisabled: false,
      hubID: this.$route.params.id,
      spaceId: window.$cookies.get("space_id"),
      url: "",
      urlRules: ruleRequired('labelLink'),
      errors: []
    };
  },
  watch: {
    url(){
      if(isUrl(this.url) || this.url == '')
      {
        this.errors = []
      }else {
        this.errors = [i18n.t('linkErrorValid')]
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
  },
  created(){
    if(Object.keys(this.item).length > 0){
      this.title = this.item.attributes.title
      this.url = this.item.attributes.url
    } 
  },
  methods: {
    async addLink() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        if(!isUrl(this.url)){
          this.errors = [i18n.t('linkErrorValid')]
        }else {
          this.loadingData = true
          try {
            let data = {
              data: {
                type: "hub-links",
                attributes: {
                  title: this.title.trim(),
                  url: this.url,
                },
                relationships: {
                  hub: {
                    data: {
                      type: "hubs",
                      id: this.$route.params.id,
                    },
                  },
                },
              },
            };
            const response = await addHubLink(data);
            if (response) {
              if (response.status == 201) {
                this.show = false;
                this.$emit("proceedSubmit", 'add-link');
                this.$refs.form.reset();
                
              }
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg = i18n.t("serverError");
              }
            } else {
              this.alertValue = true
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
          this.loadingData = false
        }   
      }
    },
    async editLink(){
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        if(!isUrl(this.url)){
          this.errors = [i18n.t('linkErrorValid')]
        }else {
          this.loadingData = true
          try {
            let data = {
              data: {
                type: "hub-links",
                id: this.item.attributes.entity_id,
                attributes: {
                  title: this.title.trim(),
                  url: this.url,
                },
                relationships: {
                  hub: {
                    data: {
                      type: "hubs",
                      id: this.$route.params.id,
                    },
                  },
                },
              },
            };
            const response = await updateHubLink(this.item.attributes.entity_id, data);
            if (response) {
              if (response.status == 200) {
                this.show = false;
                this.$emit("proceedSubmit");
                this.$refs.form.reset();
              }
            }
          } catch (e) {
            if (e.response) {
              if (e.response.status == 403) {
                this.$router.push({ name: "PageAccessDenied" });
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg = i18n.t("serverError");
              }
            } else {
              this.alertValue = true
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
          this.loadingData = false
        }   
      }
    }
  }
};
</script>